import { render, staticRenderFns } from "./GiftPanel.vue?vue&type=template&id=31094250&scoped=true"
import script from "./GiftPanel.vue?vue&type=script&lang=js"
export * from "./GiftPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31094250",
  null
  
)

export default component.exports